import { GetAccountResponseSchema, type GetAccountResponse } from '@weft/api-definition';
import { validateNotEmptyObject } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useAccountSuspense(options?: CustomUseQueryOptions<GetAccountResponse>) { 
  const useAccountResponse = useAccount({ suspense: true, ...options });

  validateNotEmptyObject(useAccountResponse.data);

  return useAccountResponse;
}

export function useAccount(options?: CustomUseQueryOptions<GetAccountResponse>) {
  return useQuery(['account'], async () => {
    const api = getPrivateApi();
    const getAccountResponse = await api.getAccount();
    
    return GetAccountResponseSchema.parse(getAccountResponse);
  }, options );
}